module.exports = __webpack_public_path__ + "img/29.844e2dcd.png";